export default function groups(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                group: action.group,
            }
        default:
            return state;
    }
}
